// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmModal_root__2swt4","actions":"ConfirmModal_actions__1lRe8"};